import PhotoSlideshow, { SlideImage } from '../../../components/feature/PhotoSlideshow';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const sliderImages: SlideImage[] = [
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/69044afa-a5bd-44fc-96a9-6cc63f51ff83_001_0037.jpg?v=0e4a0299fec93702ae5cccc2e6f3c375",
    alt: "施設写真1",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/ab193f21-1aea-4c53-98ac-010e6a864944_006_1091.jpg?v=8b1e3627cd0d603145695157a0fa70e1",
    alt: "施設写真2",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/0efd9471-6e55-4509-bf39-e332196c983e_006_2044.jpg?v=bed1d19f0191b06ef446612d8d74b2e0",
    alt: "施設写真3",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/0258b36c-001d-42c9-9043-6de8cf796dcb_002_0371.jpg?v=d1d5e7876d3169190eac3fd467a9f8f9",
    alt: "施設写真4",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/05e50df2-60a3-4206-9b88-b891cdda74c9_006_1146.jpg?v=0d9c826957b12a8e3804c3c1fbe7c561",
    alt: "施設写真5",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/cc615bf7-88bd-48d4-876e-b8066c80a12b_004_0820.jpg?v=47396e95117035a2b76cd6129acba397",
    alt: "施設写真6",
  },
];

export default function About() {
  const { ref: slideshowRef, isVisible: slideshowVisible } = useScrollAnimation(0.05);
  const { ref: textRef, isVisible: textVisible } = useScrollAnimation();

  return (
    <section id="about" className="py-24 bg-[#fafafa]">
      {/* Photo Slideshow — centered ~1000px, 16:9, horizontal slide */}
      <div
        ref={slideshowRef}
        className={`mb-16 px-6 lg:px-20 transition-all duration-[700ms] ease-out ${slideshowVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <div className="max-w-[1000px] mx-auto">
          <PhotoSlideshow
            images={sliderImages}
            autoPlayInterval={4500}
            aspectRatio="16/9"
            className="w-full"
            overlayDark
            transition="slide"
          />
        </div>
      </div>

      {/* Text — centered below slider */}
      <div
        ref={textRef}
        className={`px-6 lg:px-20 max-w-3xl mx-auto text-center transition-all duration-[600ms] ease-out ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e] leading-tight mb-5"
          style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
        >
          誰よりも上達し、楽しめる。
        </h2>
        <p className="text-[#e85d2c] text-sm font-medium tracking-wide mb-7">
          世界トップクラスの測定機能と1700以上のコース。
        </p>
        <p className="text-[#1a1a3e]/65 text-[19px] leading-[1.9]">
          Golph.club Suminoeは、大阪市住之江区北加賀屋にある、UNEEKOR正規代理店が運営する完全貸切・無人のシミュレーションゴルフ施設です。最先端のテクノロジーとトレンドを体感できる、全く新しいゴルフクラブとして60平米の完全貸切ブースで、気心の知れた仲間やご家族、恋人同士で最高の時間をお約束します。
        </p>
      </div>
    </section>
  );
}
